import React from 'react';
import { NavItem, NavItemType } from './NavItem';

export type NavListType = {
  navItems: NavItemType[];
  handleClick: () => void;
  isCollapsed?: boolean;
};

export const NavList = ({ navItems, handleClick, isCollapsed = false }: NavListType) => {
  return (
    <div className="space-y-1">
      {navItems.map((nav, index) => (
        <NavItem
          title={nav.title}
          subtitle={nav.subtitle}
          to={nav.to}
          key={nav.to}
          icon={nav.icon}
          handleClick={handleClick}
          isCollapsed={isCollapsed}
        />
      ))}
    </div>
  );
};
